 export enum NiveauAlerte {
NC = 0,
Mineur = 1,
Intermediaire = 2,
Majeur = 3,
Critique = 4,
}


// WEBPACK FOOTER //
// ./src/dto/GenApi.iNotPaie.Dto/NiveauAlerte.ts